import { apiRequest } from '../../apiCall'
import { callRatingRequest } from '../../types/callRating/apiRequestTypes'

export const getCallRating = (params: string) => apiRequest('CallRating.GetCallRatingSettings', {}, `/?customerLineId=${params}`, true)
export const setCallRating = (params: callRatingRequest) => apiRequest('CallRating.EditCallRatingSetting', { ...params }, '', true)


